import CookieService from "../services/cookie.service";


const initialState = {
  currentUser:"undefined" 
};

const loginReducer = (state = initialState, action) => {
    
    const {type,payload} = action;

    switch(type) {
        case "LOGIN":
            return {...state,currentUser:payload.currentUser}
        case "LOGOUT":
             CookieService.eraseCookie("currentUser")
            return {...state,currentUser:undefined}
        default:
            return state;
    }
};
export default loginReducer;
